function formatNumber(value) {
    const rounded = Math.round(value)
    return rounded.toLocaleString('sv-SE')
}

function animateCounter(counter) {
    const target = Number(counter.dataset.target || 0)
    const duration = Number(counter.dataset.duration || 1200)
    if (!Number.isFinite(target)) return

    const startTime = performance.now()

    function step(now) {
        const progress = Math.min((now - startTime) / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        const current = target * eased

        counter.textContent = formatNumber(current)

        if (progress < 1) {
            requestAnimationFrame(step)
        } else {
            counter.textContent = formatNumber(target)
        }
    }

    requestAnimationFrame(step)
}

function initAnimateNumbers() {
    const counters = document.querySelectorAll('.pc-animate-numbers .count')
    if (!counters.length) return

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return
                animateCounter(entry.target)
                observer.unobserve(entry.target)
            })
        },
        {
            threshold: 0.35,
        }
    )

    counters.forEach((counter) => observer.observe(counter))
}

document.addEventListener('DOMContentLoaded', initAnimateNumbers)
